module.exports = {
  accentColor: '#0078ec',
  floatingNav: {
    background: 'rgba(56, 87, 138, 0.94)',
    chevron: '#FFA726',
    color: '#FFF'
  },
  headerColor: '#448AFF',
  selectionColor: '#CBE3FB',
  textColor: {
    active: '#183e62',
    default: '#183e62'
  },
  todayColor: '#e73c58',
  weekdayColor: '#559FFF'
};